/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from 'classnames';

import type { ButtonProps } from './types';
import './button.scss';
import { Spinner } from '../Spinner';

export const Button = ({
  className,
  variant = 'primary',
  shape = 'rounded',
  size = 'medium',
  children: childrenProps,
  leftIcon,
  readonly = false,
  fullWidth = false,
  busy = false,
  disabled,
  ...restProps
}: ButtonProps) => {
  const children = (
    <>
      {leftIcon}
      <span>{childrenProps}</span>
    </>
  );

  if (readonly) {
    return (
      <span
        className={classNames(
          'payflow-ui button',
          `size-${size}`,
          disabled && 'disabled',
          className,
          variant,
          fullWidth && 'fullwidth'
        )}
      >
        {children}
      </span>
    );
  }

  return (
    <button
      className={classNames(
        'payflow-ui button',
        `size-${size}`,
        `shape-${shape}`,
        disabled && 'disabled',
        className,
        variant,
        fullWidth && 'fullwidth'
      )}
      disabled={disabled}
      {...restProps}
    >
      {busy && <Spinner />}
      {children}
    </button>
  );
};
